import { Controller } from "@hotwired/stimulus"

const INTERACTIVE_SELECTOR =
  "a, button, input, label, select, textarea, [data-action]"

export default class RowLinkController extends Controller {
  static targets = ["link"]

  navigate(event) {
    const interactive = event.target.closest(INTERACTIVE_SELECTOR)
    if (interactive && interactive !== this.element) return
    if (window.getSelection().toString()) return

    this.linkTargets.find((link) => link.offsetParent).click()
  }
}
